import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';

import { ChatComponent, CopilotFacadeService } from '@brighthub/copilot';
import { ClientListComponent } from '@brightnav/ui';
import { BrightnavLayoutComponent } from '../brightnav-layout/brightnav-layout.component';
import { BrightnavLayoutService } from '../brightnav-layout.service';
import { ClientSessionService } from '@brighthub/uisession';

@Component({
  selector: 'bn-my-clients-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChatComponent,
    ClientListComponent,
    BrightnavLayoutComponent
],
  templateUrl: './my-clients-layout.component.html',
  styleUrl: './my-clients-layout.component.scss',
})
export class MyClientsLayoutComponent {
  layoutService = inject(BrightnavLayoutService);
  clientSessionService = inject(ClientSessionService);
  private _copilotFacadeService = inject(CopilotFacadeService);
  collapsed = computed(() => this.layoutService.collapsed());

  constructor() {
    effect(() => {
      const selectedSession = this.clientSessionService.selectedSession();
      if (!selectedSession) {
        this._copilotFacadeService.clearContext();
      }
    });
  }

  ngOnInit() {
    this._copilotFacadeService.hideInput.set(false);
  }
}
